const routes = {
  home: "/",
  products: "/products",
  cart: "/cart",
  login: "/login",
  signup: "/signup",
  profile: "/profile",
  editProfile: "/profile/edit",
  changePassword: "/profile/change-password",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  aboutUs: "/about-us",
  policies: "/policies",
  contactUs: "/contact-us",
  naturalProducts: "/naturalProducts",
};

export default routes;
